import Swiper from "swiper";
import { Pagination, A11y, Autoplay } from "swiper/modules";

const initQuoteSwiper = () => {
    const swiperContainers = document.querySelectorAll(".quote-slider .swiper");

    swiperContainers?.forEach((swiperContainer) => {
        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            loopAdditionalSlides: 1,
            autoplay: {
                delay: 7000,
            },
            modules: [Autoplay, Pagination, A11y],
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    });
};

document.addEventListener("DOMContentLoaded", initQuoteSwiper);
